import React from 'react'
import PropTypes from 'prop-types'

import * as S from './style'

const InformationStatusStore = ({ onClick, children }) => {
  return (
    <S.InformationStatus
      id="VehicleSellerInformationStatusStore"
      onClick={onClick}
    >
      {children}
    </S.InformationStatus>
  )
}

InformationStatusStore.propTypes = {
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
}

export default InformationStatusStore
